
export enum EnquirySource {
    Portal = "Portal",
    ACRE = "Acre",
    Housing = "Housing"
}